/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import {FC} from 'react'
import {Routes, Route, BrowserRouter, Navigate} from 'react-router-dom'
import {PrivateRoutes} from './PrivateRoutes'
import {ErrorsPage} from '../modules/errors/ErrorsPage'
import {Logout, AuthPage, useAuth} from '../modules/auth'
import {App} from '../App'
import {AuthLayout} from '../modules/auth/AuthPage'
import {ForgotPassword} from '../modules/auth/components/ForgotPassword'
import {ResetPassword} from '../modules/auth/components/ResetPassword'
import {getInitialRoute} from './roleRouting'

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const {PUBLIC_URL} = process.env

const AppRoutes: FC = () => {
  const {currentUser} = useAuth()

  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        <Route element={<App />}>
          <Route path='error/*' element={<ErrorsPage />} />
          <Route element={<AuthLayout />} >
            <Route path='auth/forgot-password' element={<ForgotPassword />} />
            <Route path='auth/reset-password' element={<ResetPassword />} />
          </Route>
          <Route path='logout' element={<Logout />} />

          {(() => {
            if (currentUser) {
              return (
                <>
                  <Route path='/*' element={<PrivateRoutes />} />
                  <Route index element={<Navigate to={getInitialRoute(currentUser.rol)} />} />
                </>
              )
            } else {
              return (
                <>
                  <Route path='auth/*' element={<AuthPage />} />
                  <Route path='*' element={<Navigate to='/auth' />} />
                </>
              )
            }
          })()}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export {AppRoutes}
